import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Acknowledgment of Confidentiality",
    blocks: [
      { type: "p", text: "Any investor, venture capital firm, family office, strategic investor, private equity firm, incubator, accelerator, acquisition team, investment banker, advisor, analyst, or corporate development representative accessing Delta GreenX acknowledges that all materials presented are confidential, proprietary, and trade-secret information." },
      { type: "p", text: "Such materials include:" },
      { type: "ul", items: [
        "Financial models and growth simulations",
        "Market-entry frameworks",
        "Technology demonstrations",
        "AI workflow systems",
        "Customer acquisition methodologies",
        "Strategic operating models",
        "Pricing logic",
        "Commercialization strategies",
      ]},
    ],
  },
  {
    heading: "Permitted Use",
    blocks: [
      { type: "p", text: "Access is granted solely for confidential strategic evaluation." },
      { type: "p", text: "Investors may not:" },
      { type: "ul", items: [
        "Record or photograph any portion of the platform",
        "Benchmark against internal or competing investments",
        "Circulate or summarize for portfolio use",
        "Distribute to affiliated companies",
        "Create derivative products",
        "Conduct competitive replication",
        "Otherwise exploit platform intelligence without written authorization",
      ]},
    ],
  },
  {
    heading: "No Offer or Solicitation",
    blocks: [
      { type: "p", text: "Access to platform materials does not constitute:" },
      { type: "ul", items: [
        "A securities offering",
        "An investment solicitation",
        "A partnership grant",
        "A licensing opportunity",
        "An acquisition invitation",
        "A legally binding commercial commitment",
      ]},
      { type: "note", text: "Investor materials are intended only for qualified investors as defined under applicable securities laws of their jurisdiction. Forward-looking projections and pilot economics are estimates and inherently uncertain. Actual outcomes may differ materially based on market conditions, regulatory environment, counterparty performance, and execution capacity." },
    ],
  },
  {
    heading: "Right to Deny or Terminate Access",
    blocks: [
      { type: "p", text: "Delta GreenX reserves the unrestricted right to deny or terminate access to any investor suspected of:" },
      { type: "ul", items: [
        "Competitive intelligence gathering",
        "Unauthorized recording",
        "Strategic misuse",
      ]},
    ],
  },
];

export default function InvestorDisclaimer() {
  return (
    <LegalLayout
      title="Investor Access & Confidentiality Agreement"
      eyebrow="Legal · Investor"
      effective="May 1, 2026"
      lastUpdated="May 1, 2026"
      intro="The following terms apply to all investors, venture capital firms, family offices, strategic investors, private equity firms, accelerators, acquisition teams, investment bankers, advisors, analysts, and corporate development representatives accessing Delta GreenX."
      sections={sections}
      contact="legal@deltagreenx.com"
    />
  );
}
